// extracted by mini-css-extract-plugin
export default {"coolstuf":"FirstBox_coolstuf__qeg2L","workdesc":"FirstBox_workdesc__zWAEm","littleline":"FirstBox_littleline__vRWj4","containbuttons":"FirstBox_containbuttons__SZu++"};